import gql from "graphql-tag";

const getPerspectives = gql`
  query Perspective {
    perspectives {
      id
      name
      description
      planning {
        id
      }
      objectives {
        id
      }
      createdAt
      updatedAt
    }
  }
`;

const getPerspectiveById = gql`
  query Perspective($args: FilterParamsInput) {
    searchPerspectives(args: $args) {
      data {
        description
        id
        matrix {
          id
          name
          type
          perspective {
            id
          }
        }
        name
        planning {
          id
        }
        objectives {
          id
        }
      }
    }
  }
`;

export { getPerspectives, getPerspectiveById, }